var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummyMale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18258",
    "data-name": "Rectangle 18258",
    width: 96,
    height: 96,
    transform: "translate(167 608)",
    fill: "#e4eef7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_133",
    "data-name": "Mask Group 133",
    transform: "translate(-167 -608)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18260",
    "data-name": "Rectangle 18260",
    width: 96,
    height: 96,
    transform: "translate(167 608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42887",
    "data-name": "Group 42887",
    transform: "translate(10524.499 -12726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42886",
    "data-name": "Group 42886",
    transform: "translate(-10357.499 13334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71666",
    "data-name": "Path 71666",
    d: "M48.82.007A47.969,47.969,0,0,0,17.113,84.7a12.754,12.754,0,0,1,2.277-1.619l14.322-7.812A5.851,5.851,0,0,0,36.76,70.13V64.261a31.843,31.843,0,0,1-5.807-12.014,4.817,4.817,0,0,1-2.221-4.041V41.783a4.8,4.8,0,0,1,1.6-3.559V28.939S28.43,14.49,48,14.49s17.66,14.449,17.66,14.449v9.285a4.788,4.788,0,0,1,1.6,3.559v6.423a4.817,4.817,0,0,1-3.416,4.583A35.288,35.288,0,0,1,59.079,62.4a23.163,23.163,0,0,1-1.451,1.866v6.017a5.846,5.846,0,0,0,3.233,5.231L76.2,83.176a12.771,12.771,0,0,1,2.518,1.688A47.988,47.988,0,0,0,48.82.007Z",
    transform: "translate(0 0)",
    fill: "#c6def4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyMale);
export default __webpack_public_path__ + "static/media/dummy_male.ccca3b5e8617f9f7e8f3dead8778380d.svg";
export { ForwardRef as ReactComponent };